import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector } from "react-redux";
import FallBackUI from "./FallBackUI";

const PaymentEnvironment = ({ children,setQuantityDarwerOpen,showFallback }) => {
  const paymentIntentData = useSelector(
    (state) => state?.subscription?.paymentIntentData
  );

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

  const clientSecret = paymentIntentData?.secret;

  if (!clientSecret&&showFallback) {
    // Handle the absence of a clientSecret (e.g., show a loader, error message, or fallback UI)
    return <FallBackUI setQuantityDarwerOpen={setQuantityDarwerOpen}/>;
  }

  const options = {
    // Passing the client secret obtained
    clientSecret,
    // Fully customizable with appearance API
    appearance: {
      /* Customize appearance here */
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export default PaymentEnvironment;
